import {Observable, of} from 'rxjs';
import {TeamMemberService} from '../team-member.service';
import {MockedTeamMember, TeamMember} from '../../models/team-member';
import {mockProjectReferences} from './project-reference.service.mock';

export const mockTeamMembers: MockedTeamMember[] = [
    {
        id: 1,
        name: 'Hans Worst',
        role: 'TenderManager',
        projectReference: mockProjectReferences[0],
        readonly: false
    }
];

export class TeamMemberServiceMock implements TeamMemberService {
    list(refId: number): Observable<TeamMember[]> {
        return of(mockTeamMembers.filter(member => member.projectReference.id === refId));
    }
    create(refId: number, teamMember: TeamMember): Observable<TeamMember> {
        const ref = mockProjectReferences.find(reference => reference.id === refId);
        if (ref) {
            const newMember = {
                id: mockTeamMembers.length + 1,
                name: teamMember.name,
                role: teamMember.role,
                readonly: false,
                projectReference: ref
            };

            mockTeamMembers.push(newMember);
            return of(newMember);
        }
        throw Error('404 - reference not found');
    }

    delete(refId: number, teamMember: TeamMember): Observable<void> {
        const memberIdx = mockTeamMembers.findIndex(member => member.id === teamMember.id);
        if (memberIdx !== undefined) {
            mockTeamMembers.splice(memberIdx, 1);
        }

        return of();
    }

    update(refId: number, teamMember: TeamMember): Observable<TeamMember> {
        const oldMember = mockTeamMembers.find(member => member.id === teamMember.id);
        if (oldMember) {
            oldMember.name = teamMember.name;
            oldMember.role = teamMember.role;
        }

        return of(oldMember || teamMember);
    }


}
